import { render } from "./CreatePlatform.vue?vue&type=template&id=0c078d32&scoped=true"
import script from "./CreatePlatform.vue?vue&type=script&lang=js"
export * from "./CreatePlatform.vue?vue&type=script&lang=js"

import "./CreatePlatform.vue?vue&type=style&index=0&id=0c078d32&scoped=true&lang=css"

import exportComponent from "/Users/sanzharzhubatkan/Sanzhar/Work/EduCenter/local-projects/educenter-update/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c078d32"]])

export default __exports__